import React from 'react';
import { Trans } from 'react-i18next';
import RedirectPageComponents from './redirect-page.components';
import { portalsDataType } from '../../hooks/use-portals-data.hook';

interface RedirectPageContentProps {
  currentPortalData?: portalsDataType;
  targetPortalData: portalsDataType;
}

const {
  Container,
  LogoContainer,
  Logo,
  Arrow,
  Description
} = RedirectPageComponents;

const RedirectPageContent: React.FunctionComponent<RedirectPageContentProps> = ({
  currentPortalData,
  targetPortalData
}) => {
  return (
    <Container>
      <LogoContainer>
        <Logo src={currentPortalData?.logo} alt="edenred" />
        <Arrow />
        <Logo src={targetPortalData.logo} alt="edenred" />
      </LogoContainer>
      <Description className="ucf-paragraph">
        <Trans
          i18nKey={targetPortalData.redirection.description}
          values={{ link: targetPortalData.redirection.link }}
          components={{ bold: <strong /> }}
        />
      </Description>
    </Container>
  );
};

export default RedirectPageContent;
